module.exports = __webpack_public_path__ + "img/cisco.19cd6f85.png";